import Vue from 'vue';
import { ValidTool } from './validTool';
import { isTypes } from './isType';

export const Mixins = [ValidTool]; // => "hello from mixin!"
export const isRoleType = [isTypes];
